
import ModalDetailsContentFeaturesIcon from './modal-details-content-features-icon.vue'
export default {
  components: { ModalDetailsContentFeaturesIcon },
  props: {
    productSelected: {
      type: Object,
      required: true,
    },
    wordingPageProduct: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    iconActive: null,
  }),
  computed: {
    icons() {
      if (
        this.productSelected &&
        this.productSelected.icons &&
        this.productSelected.icons.length > 0
      )
        return this.wordingPageProduct.icons_list.filter((icon) =>
          this.productSelected.icons.includes(icon.key)
        )
      else return []
    },
  },
  mounted() {
    if (this.icons.length > 0) this.iconActive = this.icons[0]
  },
}
